import React from 'react';
import { IconProps } from '../types';

export const Ladder: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="16"
      cy="21.6"
      rx="14.4"
      ry="5.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2 8C11.2 7.57566 11.3685 7.16869 11.6686 6.86863C11.9686 6.56857 12.3756 6.4 12.8 6.4C13.2243 6.4 13.6313 6.56857 13.9313 6.86863C14.2314 7.16869 14.4 7.57565 14.4 8"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.40002 21.6C6.40002 21.1757 6.5686 20.7687 6.86865 20.4686C7.16871 20.1686 7.57568 20 8.00002 20C8.42437 20 8.83134 20.1686 9.1314 20.4686C9.43145 20.7687 9.60002 21.1757 9.60002 21.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8 21.6C12.8 21.1757 12.9686 20.7687 13.2687 20.4686C13.5687 20.1686 13.9757 20 14.4 20C14.8244 20 15.2314 20.1686 15.5314 20.4686C15.8315 20.7687 16 21.1757 16 21.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2 21.6C19.2 21.1757 19.3685 20.7687 19.6686 20.4686C19.9686 20.1686 20.3756 20 20.8 20C21.2243 20 21.6313 20.1686 21.9313 20.4686C22.2314 20.7687 22.4 21.1757 22.4 21.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8 21.6C12.8 22.0243 12.6315 22.4313 12.3314 22.7314C12.0314 23.0314 11.6244 23.2 11.2 23.2C10.7757 23.2 10.3687 23.0314 10.0687 22.7314C9.76862 22.4313 9.60005 22.0243 9.60005 21.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2 21.6C19.2 22.0243 19.0314 22.4313 18.7313 22.7314C18.4313 23.0314 18.0243 23.2 17.6 23.2C17.1756 23.2 16.7686 23.0314 16.4686 22.7314C16.1685 22.4313 16 22.0243 16 21.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6 21.6C25.6 22.0243 25.4314 22.4313 25.1313 22.7314C24.8313 23.0314 24.4243 23.2 24 23.2C23.5756 23.2 23.1687 23.0314 22.8686 22.7314C22.5685 22.4313 22.4 22.0243 22.4 21.6"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 8C20 7.57566 20.1686 7.16869 20.4686 6.86863C20.7687 6.56857 21.1757 6.4 21.6 6.4C22.0243 6.4 22.4313 6.56857 22.7314 6.86863C23.0314 7.16869 23.2 7.57565 23.2 8"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2 18.4V8"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 18.4V8"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2 10.4H20"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2 13.6H20"
      stroke="#333333"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
